import React from 'react';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';
import { BEACON_PRO_RIGHT_CONTENT_WIDTH } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

const TopEntityChartV2Loading = ({
  disableLegendSkeleton = false,
  enableSubTitleSkeleton = false
}: {
  disableLegendSkeleton?: boolean;
  enableSubTitleSkeleton?: boolean;
}) => {
  const legendSkeleton = (
    <Flex gap="sm">
      <SlSkeleton variant="rounded" height={23} width={152} />
    </Flex>
  );

  return (
    <Flex flexDirection="column" gap="lg">
      {enableSubTitleSkeleton && <SlSkeleton variant="rounded" height={20} width={BEACON_PRO_RIGHT_CONTENT_WIDTH} />}
      {!disableLegendSkeleton && (
        <Flex gap="lg">
          {legendSkeleton}
          {legendSkeleton}
        </Flex>
      )}

      <SlSkeleton variant="rounded" height={422} width={BEACON_PRO_RIGHT_CONTENT_WIDTH} />
    </Flex>
  );
};

export default TopEntityChartV2Loading;
